export class InitializeSolutionStateError extends Error {

}
